import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class MaxElevationComponent extends Component {
  static readonly TYPE_ID: string = 'e20751e2bb8f4fe3836e2d7383c2e662';

  constructor(
    public readonly maxElevation: number,
  ) {
    super();
  }

  get $typeId() {
    return MaxElevationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): MaxElevationComponent {
    return new MaxElevationComponent(
        MapUtils.get<number>(map, 'maxElevation'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'maxElevation': this.maxElevation,
    };
  }

  clone(): this {
    return new MaxElevationComponent(
        this.maxElevation,
    ) as this;
  }

  isSame(other: MaxElevationComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.maxElevation === this.maxElevation;
  }
}

export class MaxElevationComponentBuilder extends DataModelBuilder<MaxElevationComponent> {
  build(context: SerializationContext, map: SerializedData): MaxElevationComponent {
    return MaxElevationComponent.fromMap(context, map);
  }
}
